import React from 'react';

export interface RowMenuProps<T> {
    tabs: T[];
    activeTab: T;
    onSelectTab: (tab: T) => void;
}

export function RowMenu<T extends React.ReactNode>(props: RowMenuProps<T>) {
    const { tabs, activeTab, onSelectTab } = props;
    if (!tabs) return null;
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {tabs.map((tab, index) => (
                <button
                    className={'wfp-btn ' + (activeTab === tab ? 'active' : '')}
                    key={index}
                    onClick={() => onSelectTab(tab)}
                    style={{
                        flex: 1,
                        marginBottom: 20,
                        marginLeft: 10,
                        marginRight: 10,
                    }}
                    type={'button'}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
}
